import BaseModelAPI from '../BaseModelAPI';

export default class RoleManagement extends BaseModelAPI {
	static entity = 'rolemanagement';
	static entityName = 'rolemanagement';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.name = '';
			this.description = '';
			this.roleManagementDetail = []
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}